import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import { Box, Button, Typography, InputLabel, Select, MenuItem, Autocomplete, TextField, CircularProgress, FormControl } from "@mui/material"
import style from "./style";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import CustomInput from "../../../.././../components/CustomInput";
import DragAndDropMultiple from "../../../../../components/DragAndDropMultiple";
import { useNavigate } from "react-router-dom";
import ReturnPurchaseOrderModal from "../../../../../modals/ReturnPurchaseOrderModal";
import CancelPurchaseOrderModal from "../../../../../modals/CancelPurchaseOrderModal";


const PurchaseEditPage = ({ itemList, data, handleItemList, handleAdd, loading, supplierList, handleSupplierList }) => {
  const [product, setProduct] = useState([{
    name: "",
    desc: "", price: "", quantity: "", amount: ""
  }]);
  const [totalAmount, setTotalAmount] = useState("0");
  const [invoicesDate, setInvoiceDate] = useState(dayjs());
  const [duesDate, setDueDate] = useState(dayjs());
  const [orderNumber, setOrderNumber] = useState();
  const [supplierName, setSupplierName] = useState({ supplierName: "", supplierId: "" });
  const [category, setCategory] = useState();
  const [tax, setTax] = useState(0);
  const [discount, setDiscount] = useState(0);
  const [billNumber, setBillNumber] = useState();
  const [paymentStatus, setPaymentStatus] = useState();
  const [paymentMode, setPaymentMode] = useState()
  const [remarks, setRemarks] = useState("");
  const [bankDetails, setBankDetails] = useState();
  const [files, setFiles] = useState();
  const [cancelModalOpen, setCancelModalOpen] = useState(false);
  const [returnModalOpen, setReturnModalOpen] = useState(false);
  const navigate = useNavigate();

  const handleReturnOrder = () => {
    setReturnModalOpen(true);
  };

  const handleCancelOrder = () => {
    setCancelModalOpen(true);
  };

  const handleReturnConfirm = (data) => {
    console.log('Return order confirmed:', data);
  };

  const handleCancelConfirm = (data) => {
    console.log('Cancel order confirmed:', data);
  };

  useEffect(() => {
    if (paymentStatus === "Paid" && paymentMode === "Bank") {
      if (data && data.length > 0) {
        const defaultBank = data.find(bank => bank.isDefault);
        if (defaultBank) {
          setBankDetails(defaultBank.accountNumber);
        }
      }
    }
  }, [data, paymentMode]);

  const handleAddField = () => {
    setProduct([...product, {
      name: "",
      desc: "", price: "", quantity: "", amount: ""
    }]);
    handleItemList();
  };

  const handleProduct = (value, index, key) => {
    const updatedProjectDetails = [...product];

    if (key === "quantity" || key === "price") {
      if (Number(value) < 0) value = 0;
    }

    if (key === "quantity" || key === "price") {
      const qty = key === "quantity" ? Number(value) : Number(updatedProjectDetails[index].quantity);
      const unitCost = key === "price" ? Number(value) : Number(updatedProjectDetails[index].price);
      updatedProjectDetails[index]["amount"] = (qty * unitCost);
      calculateTotalAmount();
    }

    if (key === "name") {
      const selectedProject = itemList.find(proj => proj.title === value);
      if (selectedProject) {
        updatedProjectDetails[index].itemId = selectedProject ? selectedProject?._id : "";
        updatedProjectDetails[index].price = Number(selectedProject.purchasePrice || 0);
        updatedProjectDetails[index].desc = selectedProject ? selectedProject.desc : ""
      }
    }
    if (key === "quantity") {
      updatedProjectDetails[index][key] = Number(value);
    }
    else if (key === "price") {
      updatedProjectDetails[index][key] = Number(value);
    } else {
      updatedProjectDetails[index][key] = value;
    }


    setProduct(updatedProjectDetails);
  }
  const handleDeleteField = (index) => {
    const updatedProductInformation = [...product];
    updatedProductInformation.splice(index, 1);
    setProduct(updatedProductInformation);

  };
  const handleId = (value) => {

    const supplier = supplierList.find(proj => proj.name === value);
    setSupplierName({ supplierName: value, supplierId: supplier ? supplier?._id : "" })


  }
  const calculateTotalAmount = () => {
    let total = 0;
    product.forEach(item => {
      total += Number(item.amount);
    });
    return setTotalAmount(total);
  };
  const calculateFinalAmount = (totalAmount, discountPercent, taxPercent) => {
    const discountedAmount = totalAmount * (1 - (discountPercent || 0) / 100);
    const discountValue = totalAmount - discountedAmount;

    const taxAmount = discountedAmount * ((taxPercent || 0) / 100);

    const finalAmount = discountedAmount + taxAmount;

    return {
      finalAmount: finalAmount.toFixed(2),
      discountValue: discountValue.toFixed(2),
      taxAmount: taxAmount.toFixed(2),
    };
  };

  const { finalAmount, discountValue, taxAmount } = calculateFinalAmount(
    Number(totalAmount),
    Number(discount),
    Number(tax)
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    handleAdd(supplierName, invoicesDate, duesDate, product, discount, tax, billNumber, category, paymentStatus, paymentMode, remarks, orderNumber, finalAmount, totalAmount, bankDetails, files)
  }
  return (
    <>
      <Box px="15px" mt={2}>
        <Box sx={style.headerContainer}>
          <Typography sx={style.leaveHeading}>Edit Purchase</Typography>
        </Box>
      </Box>
      <form onSubmit={(e) => handleSubmit(e)}>
        <Grid container sx={style.mainContainer}>
          <Grid item xs={12} lg={11.8} sx={{ ...style.gridbox, px: 2 }}>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>
                  Supplier<span style={{ color: "red" }}>*</span>
                </Typography>
                <Autocomplete
                  id="autocomplete"
                  options={supplierList || []}
                  getOptionLabel={(option) => option?.name}
                  onInputChange={(event, newInputValue) => {
                    handleSupplierList(newInputValue);
                  }}
                  onChange={(event, newValue) => {
                    handleId(newValue?.name);
                  }}
                  renderInput={(params) => (
                    <>
                      <TextField
                        placeholder="Supplier"
                        {...params}
                        sx={{ ...style.modalInput, ...style.inputSpace }}
                        variant="outlined"
                        InputProps={{
                          ...params.InputProps,
                          endAdornment: (
                            <>
                              {loading ? (
                                <CircularProgress color="inherit" size={20} />
                              ) : null}
                              {params.InputProps.endAdornment}
                            </>
                          ),
                        }}
                      />
                    </>
                  )}
                />
              </Box>
              <Box sx={style.inputBox}>
                <Typography sx={style.inputText}>
                  Purchase Order<span style={{ color: "red" }}>*</span>
                </Typography>
                <CustomInput
                  variant="outlined"
                  required
                  fullWidth
                  id="order"
                  placeholder="Bill Number"
                  error={""}
                  name="Bill"
                  value={billNumber}
                  onChange={(e, val) => {
                    if (val.length <= 30 && !val.startsWith(" ")) {
                      setBillNumber(val);
                    }
                  }}
                  autoComplete="order"
                />
              </Box>
              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>
                    Date<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <DatePicker
                    sx={style.dateInput}
                    value={invoicesDate}
                    maxDate={dayjs()}
                    onChange={(value) => setInvoiceDate(value)}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
            <Box sx={style.inputSection}>
              <Box sx={style.inputBox}>
                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <InputLabel sx={style.label}>
                    Delivery Date<span style={{ color: "red" }}>*</span>
                  </InputLabel>
                  <DatePicker
                    sx={style.dateInput}
                    value={invoicesDate}
                    maxDate={dayjs()}
                    onChange={(value) => setInvoiceDate(value)}
                    slotProps={{
                      field: {
                        readOnly: true,
                      },
                    }}
                  />
                </LocalizationProvider>
              </Box>
            </Box>
          </Grid>
          <Box sx={style.itemSection}>
            <Box
              sx={{ backgroundColor: "#28AA4A", width: "2%", height: 2 }}
            ></Box>
            <Typography sx={style.gridText}>
              Item & Services<span style={{ color: "red" }}>*</span>
            </Typography>
          </Box>

          <Grid item xs={12} lg={11.8} sx={style.gridbox}>
            {product.map((item, index) => (
              <Box sx={style.leaveSection} key={index}>
                <Grid container sx={style.itemGrid}>
                  <Grid item xs={12} lg={2}>
                    <Autocomplete
                      id={`product-autocomplete-${index}`}
                      freeSolo
                      options={itemList || []}
                      getOptionLabel={(option) =>
                        typeof option === "string" ? option : option?.title
                      }
                      value={product[index]?.name ?? ""}
                      onInputChange={(event, newInputValue) => {
                        if (newInputValue.length <= 50) {
                          handleItemList(newInputValue);
                          handleProduct(newInputValue, index, "name");
                        }
                      }}
                      onChange={(event, newValue) => {
                        const input =
                          typeof newValue === "string"
                            ? newValue
                            : newValue?.title || "";
                        handleProduct(input, index, "name");
                      }}
                      renderInput={(params) => (
                        <TextField
                          placeholder="Product"
                          {...params}
                          sx={{ ...style.modalInput, ...style.inputSpace}}
                          variant="outlined"
                          InputProps={{
                            ...params.InputProps,
                            endAdornment: (
                              <>
                                {loading ? (
                                  <CircularProgress color="inherit" size={20} />
                                ) : null}
                                {params.InputProps.endAdornment}
                              </>
                            ),
                          }}
                        />
                      )}
                    />
                  </Grid>
                  <Grid item xs={12} lg={4}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="description"
                      placeholder="Description"
                      defaultValue={product[index]?.desc}
                      error={""}
                      name="desc"
                      value={product[index]?.desc}
                      onChange={(e, val) => handleProduct(val, index, "desc")}
                      // onFocus={handleFocus}
                      autoComplete="desc"
                    />
                  </Grid>
                  <Grid item xs={12} lg={1.5}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="unitCost"
                      type="number"
                      placeholder="Price"
                      defaultValue={product[index]?.price}
                      error={""}
                      name="unitCost"
                      value={product[index]?.price?.toString()}
                      onChange={(e, val) => handleProduct(val, index, "price")}
                      // onFocus={handleFocus}
                      autoComplete="unitCost"
                      inputProps={{ min: 0 }}
                    />
                  </Grid>
                  <Grid item xs={12} lg={1.5}>
                    <CustomInput
                      variant="outlined"
                      required
                      fullWidth
                      id="qty"
                      type="number"
                      placeholder="QTY"
                      error={""}
                      name="qty"
                      value={product[index]?.quantity?.toString()}
                      onChange={(e, val) =>
                        handleProduct(val, index, "quantity")
                      }
                      // onFocus={handleFocus}
                      autoComplete="qty"
                    />
                  </Grid>
                  <Grid item xs={9} lg={1.5}>
                    <TextField
                      fullWidth
                      variant="outlined"
                      value={
                        product[index]?.amount
                          ? product[index]?.amount.toFixed(2)
                          : "amount"
                      }
                      InputProps={{
                        readOnly: true,
                      }}
                    />
                  </Grid>
                  {index === 0 && (
                    <Grid item xs={1.5} lg={0.5}>
                      <Box sx={style.addIcon} onClick={handleAddField}>
                        +
                      </Box>
                    </Grid>
                  )}

                  {index !== 0 && (
                    <Grid item xs={1.5} lg={0.5}>
                      <Box
                        sx={style.deleteIcon}
                        onClick={() => handleDeleteField(index)}
                      >
                        <DeleteOutlineIcon />
                      </Box>
                    </Grid>
                  )}
                </Grid>
              </Box>
            ))}
          </Grid>
          <Grid container sx={{ ...style.lastGrid }}>
            <Grid
              item
              xs={12}
              sx={{
                display: "flex",
                justifyContent: "flex-end",
              }}
            >
              <Grid item xs={12} lg={4.5}>
                <Grid sx={{ ...style.gridboxs, px: 2 }}>
                  <Box sx={style.leaveSection}>
                    <Box sx={style.inputContainerBox}>
                      <Box sx={style.key}>
                        <Typography sx={style.descValueText}>Sub Total</Typography>
                      </Box>
                      <Box sx={style.key}>
                        <Typography sx={style.descValueText}>
                          {totalAmount}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={style.inputContainerBox}>
                      <Box sx={style.key}>
                        <Typography sx={style.descValueText}>Tax</Typography>
                      </Box>
                      <Box sx={style.key}>
                        <Typography sx={style.descValueText}>
                          +{taxAmount || 0} ({tax || 0}%)
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={style.inputContainerBox}>
                      <Box sx={style.key}>
                        <Typography sx={style.descValueText}>
                          Discount
                        </Typography>
                      </Box>
                      <Box sx={style.key}>
                        <Typography sx={style.descValueText}>
                          -{discountValue || 0} ({discount || 0}%)
                        </Typography>
                      </Box>
                    </Box>

                    <Box sx={style.inputContainerBox}>
                      <Box sx={style.key}>
                        <Typography sx={style.descValueTexts}>
                          Grand Total
                        </Typography>
                      </Box>
                      <Box sx={style.key}>
                        <Typography sx={style.descValueTexts}>
                          {finalAmount}
                        </Typography>
                      </Box>
                    </Box>
                  </Box>
                </Grid>
                <Box sx={style.mainBoxes}>
                  <Box sx={style.createJob}>
                    <Button
                      variant="contained"
                      onClick={() => navigate("/dashboard/purchase")}
                      color="success"
                      sx={style.cancelButtons}
                    >
                      Cancel
                    </Button>
                  </Box>
                  <Box sx={style.createJob}>
                    <Button
                      disabled={
                        !supplierName?.supplierName ||
                        !invoicesDate ||
                        !duesDate ||
                        !billNumber ||
                        paymentStatus === "Paid" && !paymentMode ||
                        paymentMode === "Bank" && !bankDetails ||
                        product.some(
                          (p) =>
                            !p.amount?.toString().trim() ||
                            !p.desc?.toString().trim() ||
                            !p.name?.toString().trim() ||
                            !p.quantity?.toString().trim() ||
                            !p.price?.toString().trim() ||
                            p.price == 0 ||
                            p.quantity == 0
                        )
                      }
                      variant="contained"
                      type="submit"
                      color="success"
                      sx={style.jobButtons}
                    >
                      Add Purchase
                    </Button>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </form>
      <ReturnPurchaseOrderModal
        open={returnModalOpen}
        onClose={() => setReturnModalOpen(false)}
        onConfirm={handleReturnConfirm}
      />

      <CancelPurchaseOrderModal
        open={cancelModalOpen}
        onClose={() => setCancelModalOpen(false)}
        onConfirm={handleCancelConfirm}
      />
    </>
  );
}
export default PurchaseEditPage;
